import { useEffect, useState } from "react";
import { useSelector } from "react-redux";
import {
  MessageThread,
  MessageThreadType,
  getDefaultUserAvatar,
} from "winslow-core";
import {
  selectEmployees,
  selectPersonas,
} from "../redux/features/agent/agentSlice";

export type ThreadContextInfo = {
  avatar?: string;
  label: string;
  threadType: MessageThreadType;
} | null;

export const useMessageThreadInfo = (
  messageThread?: MessageThread
): ThreadContextInfo => {
  const employees = useSelector(selectEmployees);
  const personas = useSelector(selectPersonas);
  const [contextInfo, setContextInfo] = useState<ThreadContextInfo>(null);

  useEffect(() => {
    if (!messageThread) {
      setContextInfo(null);
      return;
    }

    if (messageThread.threadType === MessageThreadType.NONE) {
      setContextInfo({
        label: "",
        threadType: MessageThreadType.NONE,
      });
      return;
    }

    if (messageThread.threadType === MessageThreadType.PERSONA) {
      const persona = personas.find((p) => p.id === messageThread.personaId);
      if (persona) {
        setContextInfo({
          label: persona.name,
          threadType: MessageThreadType.PERSONA,
        });
        return;
      } else {
        setContextInfo({
          label: "This persona is no longer available.",
          threadType: MessageThreadType.PERSONA,
        });
        return;
      }
    } else if (messageThread.threadType === MessageThreadType.EMPLOYEE) {
      const employee = employees.find((e) => e.id === messageThread.employeeId);
      if (employee) {
        setContextInfo({
          avatar: employee.avatar || getDefaultUserAvatar(employee.displayName),
          label: employee.displayName || employee.email,
          threadType: MessageThreadType.EMPLOYEE,
        });
        return;
      } else {
        setContextInfo({
          label: "This employee is no longer available.",
          threadType: MessageThreadType.EMPLOYEE,
        });
        return;
      }
    }

    setContextInfo(null);
  }, []);

  return contextInfo;
};
